<template>
  <div class="fees-list">
        <div class="loader" v-if="contents.loading">
          <span aria-hidden="true" class="spinner-border"></span>
      </div>
  <div v-if="contents.fees.length">
    <TableHeader :headers="Object.keys(contents.fees[0])" :widths="state.widths" :ignore="['id']"/>
    </div>
    <div v-if="contents.fees.length">
      <FeeList 
        :widths="state.widths" 
        v-for="fee in contents.fees" 
        :key="fee.id" 
        :contents="fee ? Object.values(fee) : {}"
        :handleRedirect="handleRedirect"
      />
        <div
                class="table__details"
                v-if="contents.fees.length"
        >
            <div class="table__details__left">
                <span class="text-muted" v-if="contents.pageInfo.total_pages">Page {{ contents.pageInfo.current_page }} of {{ contents.pageInfo.total_pages }}</span>
            </div>
            <div class="table__details__right">
                <Pagination :numberOfPages="contents.pageInfo.total_pages" />
            </div>
            <div class="table__details__right"></div>
        </div>
    </div>
  </div>
</template>
<script>
import { reactive, onBeforeMount, computed, watch, onMounted } from '@vue/composition-api'
import Table from '@/components/table.vue'
import TableHeader from '@/components/tableheader.vue'
import FeeList from'@/components/feelist.vue'
import Button from '@/components/button.vue';
import Pagination from "../../../components/pagination";

export default {
  components: {
      Pagination,
    Table,
    TableHeader,
    FeeList,
    Button
  },
  setup(props, { root }) {
    const store = root.$store;
    const contents = computed(() => store.getters.getFees);
    const state = reactive({
       widths: ['10%','25%','25%','15%','25%']
    });

    onBeforeMount(() => {
      store.dispatch('getExistingFees', { page: root.$route.params.page ? `${root.$route.params.page}` : '1' })
    })

    watch(() => root.$route.query, (val) => {
        store.dispatch('getExistingFees', val)
    })

    const handleRedirect = id => {
      root.$router.push({ name: "settings-fee-edit", params: { id } })
    }

    function linkGen(pageNum) {
      return '?page=' + pageNum
    }

    return {
      state,
      handleRedirect,
      contents,
      linkGen
    }
  }
}
</script>
<style lang="scss">
.fees-list {
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;

  &__header {
    display: flex;
    justify-content: flex-end;
    padding: 25px;

    .btn {
      padding: 10px 30px;
    }
  }
}

</style>
